import { Box, Stack, styled } from '@mui/material';
import { Divider } from '../../atoms/layout';
import { PropsWithChildren } from 'react';

/**
 * @deprecated
 */
export const DrawerContainer = styled(Stack)(({ theme }) => ({
  height: '100%',
}));

/**
 * @deprecated
 */
export const DrawerHeaderContainer = styled(Box)(({ theme }) => ({
  margin: theme.spacing(2),
}));

/**
 * @deprecated
 */
export const DrawerPane = styled(Box)(({ theme }) => ({
  maxHeight: `calc(100% - ${theme.spacing(4)})`,
  height: `calc(100% - ${theme.spacing(4)})`,
  overflow: 'auto',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

type DrawerControlsContainerProps = {
  divider?: boolean;
}
/**
 * @deprecated
 */
export function DrawerControlsContainer({divider = false,children}: PropsWithChildren<DrawerControlsContainerProps>) {
  return (
    <>
      {divider && (
        <Divider sx={{ m: 0 }} />
      )}
      <Box width="100%" px={2} py={1}>
        {children}
      </Box>
    </>
  )
}
